import { Box, Stack } from "@mui/material";

import { GqlPermissions } from "~/__generated__";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import { ProjectReviewVisitV2OverviewPanelSkeleton } from "../../../components/ProjectReviewVisitV2OverviewPanel/skeleton";
import FinalReportFunctionsCardSkeleton from "./FinalReportFunctionsCard/FinalReportFunctionsCardSkeleton";
import FinalReportObservationsCardSkeleton from "./FinalReportObservationsCard/FinalReportObservationsCardSkeleton";
import FinalReportSummaryCardSkeleton from "./FinalReportSummaryCard/FinalReportSummaryCardSkeleton";
import FinalReportVisitCardSkeleton from "./FinalReportVisitCard/FinalReportVisitCardSkeleton";
import FinalReportWeatherCardSkeleton from "./FinalReportWeatherCard/FinalReportWeatherCardSkeleton";

export function ProjectReviewVisitV2FinalReportRouteSkeleton() {
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);

    return (
        <GaiaPageLayoutColumn maxWidth="xl">
            <Stack direction="row" columnGap={2}>
                <Stack rowGap={2} sx={{ flex: 2 }}>
                    <FinalReportVisitCardSkeleton />
                    {isAdmin && <FinalReportSummaryCardSkeleton />}
                    <FinalReportFunctionsCardSkeleton />
                    <FinalReportWeatherCardSkeleton />
                    <FinalReportObservationsCardSkeleton />
                </Stack>
                <Box position="sticky" top={0} alignSelf="flex-start" sx={{ flex: 1 }}>
                    <ProjectReviewVisitV2OverviewPanelSkeleton />
                </Box>
            </Stack>
        </GaiaPageLayoutColumn>
    );
}
